export default __webpack_public_path__ + "static/assets/b3fc26863520901243d26315e8f0a491.svg";